/* @flow */
/* eslint import/prefer-default-export: 0 */

import { find, compose, filter } from 'lodash/fp';

export function isInvalidCategory(
  sports: Object,
  sportSlug?: ?string,
  categorySlug?: ?string = null
) {
  if (Object.keys(sports).length === 0) return false;
  if (!sportSlug) return false;
  if (!sports[sportSlug]) return true;
  if (!categorySlug) {
    return !sports[sportSlug];
  }
  return !find({ slug: categorySlug }, sports[sportSlug].subcategories);
}

export function getSportBySportId(items: Array<Object>, sportId: string) {
  // prettier-ignore
  return compose(
    find(item => item.filterValues.includes(sportId)),
    filter(item => item.filterKey === 'sportId'),
  )(items);
}
